import { useTranslate } from '@c3po/i18n'
import { Footer as BaseFooter } from '@front-web/footer'
import { useAuth } from '@narf/auth'

import React, { useMemo } from 'react'

const Footer = () => {
  const { siteId } = useAuth()
  const { i18n } = useTranslate()
  const paymentsNames = useMemo(
    () => ({
      credit_card: i18n('postsales.footer.payment.icon.bank_card'),
      visa: i18n('postsales.footer.payment.icon.visa'),
      pay: i18n('postsales.footer.payment.icon.pay'),
      amex: i18n('postsales.footer.payment.icon.amex'),
      paylib: i18n('postsales.footer.payment.icon.paylib'),
      mastercard: i18n('postsales.footer.payment.icon.mastercard'),
      paypal: i18n('postsales.footer.payment.icon.paypal'),
      illicado: i18n('postsales.footer.payment.icon.illicado'),
      confianza: i18n('postsales.footer.payment.icon.confianza'),
      verisign: i18n('postsales.footer.payment.icon.verisign'),
      pagoseguro: i18n('postsales.footer.payment.icon.pagoseguro'),
      bancontact: i18n('postsales.footer.payment.icon.bancontact'),
      ideal: i18n('postsales.footer.payment.icon.ideal'),
      maestro: i18n('postsales.footer.payment.icon.maestro'),
      klarna: i18n('postsales.footer.payment.icon.klarna'),
      applepay: i18n('postsales.footer.payment.icon.applepay'),
      floa: i18n('postsales.footer.payment.icon.floa'),
      bizum: i18n('postsales.footer.payment.icon.bizum'),
    }),
    []
  )

  return <BaseFooter dataPath={`/api/navigation/getfooter/${siteId}`} siteId={siteId} paymentsNames={paymentsNames} />
}

export default Footer
